import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BannerService, HandleErrorsService } from '../app-services';

export const adminBannerResolver: ResolveFn<unknown> = route => {
  const bannerService = inject(BannerService);
  const handleErrors = inject(HandleErrorsService);
  const id = route.parent?.params['id'];

  return bannerService.getBannerOrNull(id).pipe(
    catchError((err: unknown) => {
      handleErrors.handleErrors(err);

      return of(null);
    }),
  );
};
